import React, { useEffect, useState } from "react";
import { Link } from "react-router";
import { useCart } from "react-use-cart";

function Navbar() {
  const { totalItems } = useCart();
  const [favCount, setFavCount] = useState(0);

useEffect(() => {
  const loadFavorites = () => {
    const savedFavorites = JSON.parse(localStorage.getItem("favorites")) || [];
    setFavCount(savedFavorites.length);
  };

  loadFavorites(); 

  window.addEventListener("favoritesUpdated", loadFavorites);

  return () => window.removeEventListener("favoritesUpdated", loadFavorites);
}, []);


  return (
    <div>
      <>
        {/* start navbar home  */}
        <div className="navbar-home">
          {/* Start Top Nav */}
          <nav
            className="navbar navbar-expand-lg bg-dark navbar-light d-none d-lg-block"
            id="templatemo_nav_top"
          >
            <div className="container text-light">
              <div className="w-100 d-flex justify-content-between">
                <div>
                  <i className="fa fa-envelope mx-2" />
                  <a
                    className="navbar-sm-brand text-light text-decoration-none"
                    href="mailto:info@company.com"
                  >
                    info@company.com
                  </a>
                  <i className="fa fa-phone mx-2" />
                  <a
                    className="navbar-sm-brand text-light text-decoration-none"
                    href="tel:010-020-0340"
                  >
                    010-020-0340
                  </a>
                </div>
                <div>
                  <a
                    className="text-light"
                    href="https://fb.com/templatemo"
                    target="_blank"
                    rel="sponsored"
                  >
                    <i className="fab fa-facebook-f fa-sm fa-fw me-2" />
                  </a>
                  <a
                    className="text-light"
                    href="https://www.instagram.com/"
                    target="_blank"
                  >
                    <i className="fab fa-instagram fa-sm fa-fw me-2" />
                  </a>
                  <a
                    className="text-light"
                    href="https://twitter.com/"
                    target="_blank"
                  >
                    <i className="fab fa-twitter fa-sm fa-fw me-2" />
                  </a>
                  <a
                    className="text-light"
                    href="https://www.linkedin.com/"
                    target="_blank"
                  >
                    <i className="fab fa-linkedin fa-sm fa-fw" />
                  </a>
                </div>
              </div>
            </div>
          </nav>
          {/* Close Top Nav */}
          {/* Header */}
          <nav className="navbar navbar-expand-lg navbar-light bg-white shadow">
            <div className="container d-flex justify-content-between align-items-center">
              <Link
                className="navbar-brand text-success logo h2 align-self-center"
                to="/"
              >
                <i className="fa-solid fa-cart-plus" />
                  <b>Online</b>
                <span> store</span>
              </Link>
              <button
                className="navbar-toggler border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#templatemo_main_nav"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>
              <div
                className="align-self-center collapse navbar-collapse flex-fill d-lg-flex justify-content-lg-between"
                id="templatemo_main_nav"
              >
                <div className="flex-fill links-navbar text-center m-auto">
                  <ul className="nav navbar-nav d-flex justify-content-between mx-lg-auto">
                    <li className="nav-item">
                      <Link className="nav-link" to="/">
                        Home
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/about">
                        About
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/shop">
                        Shop
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-link" to="/contact">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="navbar align-self-center d-flex">
                  <div className="m-auto">

                    <Link
                      className="nav-icon position-relative text-decoration-none text-center"
                      to="/cart"
                    >
                      <i className="fa fa-fw fa-cart-arrow-down text-dark mr-1" />
                      <span className="position-absolute top-0 left-100 translate-middle badge rounded-pill bg-success text-white">
                        {totalItems}
                      </span>
                    </Link>
                    <Link
                      className="nav-icon position-relative text-decoration-none"
                      to="/favorites"
                    >
                      <i className="fa-solid fa-heart text-dark mr-3" />
                      <span className="position-absolute top-0 left-100 translate-middle badge rounded-pill bg-success text-white">
                        {favCount}
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </nav>
          {/* Close Header */}
        </div>
        {/* end navbar home  */}
      </>
    </div>
  );
}

export default Navbar;
